// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSettingBarsIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M16.5 2c.83 0 1.5.67 1.5 1.5V8h1c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h1V3.5c0-.83.67-1.5 1.5-1.5m0 20c.83 0 1.5-.67 1.5-1.5V12h-3v8.5c0 .83.67 1.5 1.5 1.5M9 20.5V18H6v2.5c0 .83.67 1.5 1.5 1.5S9 21.33 9 20.5m2-5.5c0-.55-.45-1-1-1H9V3.5C9 2.67 8.33 2 7.5 2S6 2.67 6 3.5V14H5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1" />
  </g>
);
export default SvgSettingBarsIcon;
SvgSettingBarsIcon.displayName = 'SvgSettingBarsIcon';
